import { createSlice } from '@reduxjs/toolkit';

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState: {
    logsCriteria: null,
  },
  reducers: {
    setTenantLogsCriteria: (state, action) => {
      state.logsCriteria = action.payload;
    },
  },
});

export const { setTenantLogsCriteria } = tenantSlice.actions;

export const selectTenantLogsCriteria = (state) => state.tenant.logsCriteria;

export default tenantSlice.reducer;
